import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Logo from "@/components/Logo";

export default function LegalLayout({ label, title, updated, intro, children }) {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
  }, []);

  return (
    <div className="bg-[#F3F2F2] min-h-screen" data-testid="legal-page">
      <Navbar />

      <header className="bg-[#2E9EF0] border-b-2 border-[#12263A]">
        <div className="max-w-3xl mx-auto px-5 py-16 md:py-20">
          <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#12263A] bg-[#FFC533] border-2 border-[#12263A] rounded-full px-4 py-1">
            {label}
          </span>
          <h1
            className="mt-6 text-[#12263A] font-black leading-[1.02] text-4xl sm:text-5xl lg:text-[56px]"
            style={{ letterSpacing: "-0.02em" }}
          >
            {title}
          </h1>
          {updated && <p className="mt-4 text-[14px] font-bold text-[#12263A]">Última actualización: {updated}</p>}
          {intro && <p className="mt-4 text-[17px] leading-[1.6] text-[#12263A] max-w-xl">{intro}</p>}
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 py-14 md:py-20">
        <article className="space-y-10">{children}</article>

        <div className="mt-16 bg-[#12263A] border-2 border-[#12263A] p-8 flex flex-col items-start gap-4" style={{ borderRadius: "28px" }}>
          <Logo size={34} showText={false} />
          <p className="text-[17px] font-black text-[#F3F2F2] leading-snug max-w-md">
            ¿Alguna duda sobre tus datos o estos términos? Escríbenos, te respondemos como a una familia.
          </p>
          <button
            onClick={() => navigate("/")}
            data-testid="legal-back-btn"
            className="px-6 py-3 rounded-[18px] bg-[#2E9EF0] text-[#12263A] border-2 border-[#F3F2F2] font-bold hover:bg-[#F3F2F2] transition-colors"
          >
            Volver al inicio
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export function LegalSection({ id, n, title, children }) {
  return (
    <section id={id} className="scroll-mt-24">
      <div className="flex items-baseline gap-3">
        {n && <span className="text-[15px] font-black text-[#2E9EF0]">{n}</span>}
        <h2 className="text-[22px] md:text-[26px] font-black text-[#12263A] leading-tight">{title}</h2>
      </div>
      <div className="mt-3 space-y-3 text-[16px] leading-[1.7] text-[#2A3D52]">{children}</div>
    </section>
  );
}
